<template>
  <div class="w-full">
    <vx-tooltip :text="$t('add') | capitalize">
      <vs-button
        color="success"
        icon-pack="feather"
        icon="icon-plus"
        type="filled"
        @click="open"
        class="w-full"
      >
        <!-- <span>{{ $t('add') }}</span> -->
      </vs-button>
    </vx-tooltip>
    <vs-popup-custom
      :title="$t('add_new_payday') | capitalize"
      color="danger"
      :active.sync="active"
      :buttonCloseHidden="true"
      :persistent="true"
    >
      <div id="add-payday-loading" class="vs-con-loading__container">
        <form class="px-2">
          <div class="popup-custom-h">
            <vs-row class="mb-2">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $tc('client') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <v-select
                  v-model="form.client_id"
                  :options="clients"
                  class="w-full select-h"
                  :reduce="(item) => item.ClientId"
                  label="ClientName"
                  :clearable="false"
                />
              </vs-col>
            </vs-row>

            <vs-row class="mb-2">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $tc('payday') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <v-select
                  v-model="form.payday"
                  :options="days"
                  class="w-full select-h"
                  :reduce="(item) => item.value"
                  label="label"
                  :clearable="false"
                />
              </vs-col>
            </vs-row>
          </div>
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button class="w-full mx-2" type="border" @click="close">
                {{ $t('cancel') | capitalize }}
              </vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button
                class="w-full mx-2"
                type="filled"
                color="primary"
                :disabled="disabledSubmit"
                @click="handleSubmit"
              >
                {{ $t('submit') | capitalize }}
              </vs-button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from '../request'

export default {
  components: {
    VsPopupCustom,
    'v-select': vSelect,
  },
  props: {
    vendorId: {
      required:true
    },
    clients: {
      type: Array,
      default: () => [],
    },
    days: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    disabledSubmit() {
      return this.form.client_id === '' || this.form.payday === ''
    },
  },
  data() {
    return {
      active: false,
      form: {
        client_id: '',
        payday: '',
      },
    }
  },
  methods: {
    open() {
      this.form = {
        client_id: '',
        payday: '',
      }
      this.active = true
    },
    close() {
      this.active = false
    },
    handleSubmit() {
      const payload = {
        vendor: this.vendorId,
        client: this.form.client_id,
        payday: this.form.payday,
      }
      this.openLoading('add-payday-loading')
      request
        .addPayday(payload)
        .then((response) => {
          this.closeLoading('add-payday-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Payday Saved',
          })
          this.close()
          this.$emit('success')
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('add-payday-loading')
        })
    },
  },
  mixins: [loading],
}
</script>

<style>
.select-h > .vs__dropdown-menu {
  height: 50px;
  overflow-x: hidden;
}
.popup-custom-h {
  height: 140px;
}
</style>